<template>
    <div v-loading="loading">
         <navBox></navBox>
        <!-- <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div> -->
        <div class="banner">
                <img src="@/assets/News/banner.png" alt="" />
        </div>
        <div class="wrap news-crumbs">
            <div class="crumbs">
                <span>HOME</span> > <span>NEWS</span> > <span>{{title}}</span> > 
                <label>   
                    {{subTitle}}
                    
                </label>
            </div>
        </div>
        <div class="title">
            <div class="wrap news-title">
                 <div class="big">{{subTitle}}</div>  
                 <div class="small">{{ctime}}</div> 
            </div>
        </div>
        <div class="wrap news-content">
            <!-- <div class="centent-one">Nexters proceeds to grow, while merger with Kismet Acquisition One secured additional investments and is now expected to close by the end of Q3!</div>
            <div class="content-two">After great results in Q1 and raising the forecast for the whole year, in Q2 Nexters proceeded to show strong financial and operating performance. Fueled by successful marketing initiatives, Nexters reached $154 million in Bookings in Q2 2021 — 40% higher year-over-year for the same period in 2020. This rapid growth came with an increase of monthly paying players by 43% year-over-year to approximately 400,000 paying players.</div>
            <div class="content-three">Additional investment has been secured thus letting Nexters to meet the minimum cash condition required under the business combination agreement. $50 million will be invested via PIPE by Mubadala Investment Company and VPE Capital. Along with $50 million from Kismet it provides transaction security for closing the merger deal which is now expected by the end of Q3 2021, which is still subject to regulatory approval and other customary conditions.</div>
            <div class="content-four">After that, Nexters is expected to trade on Nasdaq under the “GDEV” ticker symbol.</div> -->
            <div class="centent-one" v-html="subExplain"></div>
        </div>
        
        <div class="pl"></div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import navBox from "@/components/navBox/navBox";
import footerBox from "@/components/footerBox/footerBox";
export default {
    name: "NewsDetails",
    components: { footerBox,navBox },
    data(){
        return{
            loading:false,
            detailsIds:[],
            detailsIds2:[],
            title:'',
            subTitle:'',
            subExplain:'',
            types: "",
            fullpathImg:"",
            pathUrl:'',
            ctime:''
        }
    },
    created() {
        this.getNewsListpg2() 
    },
    methods: {
        async getNewsListpg2() {
            this.loading=true;
            let data = await this.$http.getNewsListpg2()
            let data2 = await this.$http.getNewsListpg3()
            this.detailsIds=data.list.map(item=>item.id)
            this.detailsIds2=data2.list.map(item=>item.id)
            var id=this.$route.query.id;
            if(this.detailsIds.includes(id/1)){
                this.title='PRESS RELEASES'
                let subContent=data.list.find(item=>{return item.id==id})
                this.subTitle=subContent.title
                this.subExplain=subContent.content
                this.ctime=subContent.utime
            }else{
                this.title='IN THE NEWS' 
                let subContent=data2.list.find(item=>{return item.id==id})
                this.subTitle=subContent.title
                this.subExplain=subContent.content
                this.ctime=subContent.ctime
            }
            this.loading=false;
        },
    }
}
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.pl {
    height: 85px;
}//间距
//正文
.news-crumbs{
     display: flex;
    /*实现垂直居中*/
    align-items: center;
    height: 45px;
    .crumbs{
        font-size: 12px;
        span{
            color:#333333;
            cursor: pointer;
        }
        label{
            color: #888888;
        }
    }
}
.title{
    background: #f2f2f2;
    height: 185px;
    .news-title{
        .big{
            padding: 37px 80px;
            font-size: 30px;
            color: #333333;
        }
        .small{
            color: #888888;
            font-size: 13px;
            padding: 0 80px;
        }
    }
}
.news-content{
    margin-top: 38px;
    // border-top: 1px solid #e9e9e9;
    font-size: 16px;
    color: #333333;
    font-family: 'Lucida Bright';
    div{
        padding: 0 80px;
    }
    .centent-one{
        margin-top: 30px;
    }
    .content-two,.content-three,.content-four{
        margin-top: 40px;
    }
}
</style>